// printFormReducer
import { printFormConstants } from '../actions/constants'

const initialState = {
    printForm: null,
    loading: false,
    error: null,
    formData: {
        customerName: '',
        customerAddress: '',
        customerPhone: '',
        customerWhatsApp: '',
        orderComment: '',
        deceasedInfo: {
            name: '',
            surname: '',
            patronymic: '',
            dates: '',
            epitaph: '',
            portraitInfo: '',
        },
        orderDetails: [],
        additionalItems: [],
        productParams: [],
        orderPhotos: [],
        installationDate: { year: '', month: '', day: '' },
        displayDate: { year: '', month: '', day: '' },
        geoMark: {
            url: '',
            lat: '',
            lng: '',
            address: ''
        },
        acceptedBy: '',
        pdfs: []
    },
}

export default (state = initialState, action) => {
    switch (action.type) {
        case printFormConstants.SET_PREVIEW_FORM_DATA:
            return {
                ...state,
                formData: {
                    ...state.formData,
                    ...action.payload,
                },
            }

        case printFormConstants.GET_PRINT_FORM_REQUEST:
        case printFormConstants.UPDATE_PRINT_FORM_REQUEST:
        case printFormConstants.FINALIZE_PRINT_FORM_REQUEST:
        case printFormConstants.DELETE_PRINT_FORM_PDF_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case printFormConstants.GET_PRINT_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                printForm: action.payload.printForm,
                formData: {
                    ...state.formData,
                    ...(action.payload.printForm || {})
                }
            }

        case printFormConstants.UPDATE_PRINT_FORM_SUCCESS:
        case printFormConstants.FINALIZE_PRINT_FORM_SUCCESS:
        case printFormConstants.DELETE_PRINT_FORM_PDF_SUCCESS:
            return {
                ...state,
                loading: false,
                printForm: action.payload.printForm,
                formData: {
                    ...state.formData,
                    ...(action.payload.printForm || {})
                }
            }

        case printFormConstants.GET_PRINT_FORM_FAILURE:
        case printFormConstants.UPDATE_PRINT_FORM_FAILURE:
        case printFormConstants.FINALIZE_PRINT_FORM_FAILURE:
        case printFormConstants.DELETE_PRINT_FORM_PDF_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            }

        default:
            return state
    }
}